module.exports = __webpack_public_path__ + "vue/img/sysback.ccd667c4.png";